import { render, staticRenderFns } from "./BoardSelect.vue?vue&type=template&id=cb4fbdd2&"
import script from "./BoardSelect.vue?vue&type=script&lang=js&"
export * from "./BoardSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports